import React from 'react';
import QRCodeCanvas from 'qrcode.react';
import { FaWhatsapp } from 'react-icons/fa';
import logo from '../../../assets/logo.png';
import '../stylesCartao.css';
import { useAuth } from '../../../hooks/auth';
import { ContainerPrint } from '../styles';

export default function ImprimirCartaoVisita() {
  const { id_empresa } = useAuth();
  const dados = JSON.parse(localStorage.getItem('visit-card-data'));
  const quantidade = Array(parseInt(dados.quantidade)).fill(0);
  let tm = parseInt(dados.tamanho.replace('px', '')) + 9;
  const imprimir = () => {
    document.getElementById('buttonPrintCartao').style.display = 'none';
    window.print();
    window.close();
    document.getElementById('buttonPrintCartao').style.display = 'block';
  };
  sessionStorage.clear();
  return (
    <ContainerPrint>
      {quantidade.map((index) => (
        <div key={index} className="container-impressao-cartao">
          <div className="cartao-cabecalho" style={{ fontSize: dados.tamanho }}>
            {dados.empresa.NomeFantasia}
          </div>
          <div
            className="cartao-texto"
            style={{ fontFamily: dados.fonte, fontSize: dados.tamanho }}
          >
            {dados.mensagem}
          </div>
          <div className="cartao-qr-code">
            <QRCodeCanvas
              value={`${process.env.REACT_APP_URL}${id_empresa}`}
              size={180}
              level="Q"
            />
          </div>
          {dados.empresa.Celular && (
            <div
              className="cartao-whatsapp"
              style={{ fontFamily: dados.fonte, fontSize: dados.tamanho }}
            >
              <FaWhatsapp size={tm} color="#34af23" /> {dados.empresa.Celular}
            </div>
          )}
          <div className="cartao-rodape">
            <img src={logo} className="cartao-img" alt="..." />
          </div>
        </div>
      ))}
      <button
        className="button btn-success"
        id="buttonPrintCartao"
        title="Imprimir"
        onClick={imprimir}
      >
        Imprimir
      </button>
    </ContainerPrint>
  );
}
